import { render } from "./SidebarProfile.vue?vue&type=template&id=a4f92e4a&scoped=true"
import script from "./SidebarProfile.vue?vue&type=script&lang=js"
export * from "./SidebarProfile.vue?vue&type=script&lang=js"

import "./SidebarProfile.vue?vue&type=style&index=0&id=a4f92e4a&lang=css"
import "./SidebarProfile.vue?vue&type=style&index=1&id=a4f92e4a&scoped=true&lang=css"

import exportComponent from "/var/www/karman/karman_crm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4f92e4a"]])

export default __exports__